module.exports = __webpack_public_path__ + "img/newCheck.ff34159d.png";